import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService } from '../app.service';

import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../shared/libs/auth/auth.service';

@Injectable()
export class CommonService {
	private baseUrl: string;
	readonly #httpClient = inject(HttpClient);
	readonly #authService = inject(AuthService);

	constructor(
		private appService: AppService,
		private http: HttpClient
	) {
		this.baseUrl = this.appService.utilsUrls.apiUrl;
	}

	/*abbiamo un utente di prova perche i file caricati da fotografo devono essere in stato Uploaded, mentre quelli caricati dalla company sono in stato Approved */
	uploadFiles(formData: FormData, tempUserType: string): Observable<Array<string>> {
		const url = this.baseUrl + '/Common/UploadFiles?tempUserType=' + tempUserType;
		const token = this.#authService.getTokenValue;
		const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
		return this.#httpClient.post<Array<string>>(url, formData, { headers });
	}

	uploadZipToBlobStorage(formData: FormData): Observable<HttpEvent<any>> {
		const token = this.#authService.getTokenValue;
		const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
		return this.http.post<any>(`${this.baseUrl}/Common/UploadZipToBlobStorage`, formData, {
			reportProgress: true,
			observe: 'events',
			headers
		});
	}

	getUploadInstanceDetails(instanceId: string): Observable<any> {
		const url = this.baseUrl + '/Common/process-zip-file-status/' + instanceId;
		const token = this.#authService.getTokenValue;
		const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
		return this.#httpClient.get<any>(url, { headers });
	}
}
